<template>
  <div class="mobile_view">
    <div class="right-content">
      <quiz-overview></quiz-overview>
    </div>
    <div class="left-content">
      <div class="quiz-content">
        <h2>Is there anything else would you like to discuss with the doctor?</h2>
      </div>
      <textarea v-model="additionalInfo" row="10" placeholder="Write down your concerns...."></textarea>
      <div class="button-content">
        <button class="btn-prev w-btn us-btn-style_2" @click="prevQuiz">
          <span class="w-btn-label">&larr; Prev</span>
        </button>
        <button
            class="btn-next w-btn us-btn-style_1"
            :class="[additionalInfo ? 'btn-active' : '']"
            @click="nextQuiz">
          <span class="w-btn-label">Next &rarr;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import QuizOverview from "./QuizOverview.vue";

export default {
  name: "QuizAdditionalInfo",

  components: { QuizOverview },

  data() {
    return {
      additionalInfo: ""
    };
  },

  created: function() {
    this.additionalInfo = this.getAdditionalInfo
        ? this.getAdditionalInfo
        : this.additionalInfo;
  },

  computed: {
    ...mapGetters( ["getAdditionalInfo"] )
  },

  methods: {
    ...mapMutations( ["setStep", "setAdditionalInfo"] ),

    prevQuiz() {
      this.setStep( 4 );
    },

    nextQuiz() {
      this.setStep( 7 );
      this.setAdditionalInfo( this.additionalInfo );
    }
  }
};
</script>

<style scoped>
textarea {
  height: 300px;
  box-shadow: 2px 2px 4px rgba(170, 170, 170, 0.5);
  position: relative;
  margin: 0;
  width: 100%;
}
</style>
